import { withStyles } from '@material-ui/core/styles';
import "@triply/yasgui/build/yasgui.min.css";
import YASQE from "@triply/yasqe";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles } from '../style/gstheme';
import "../style/sparql-editor.css";
import classesCompleter from './classesCompleter';
import prefixCompleter from './prefixCompleter';
import propertiesCompleter from './propertiesCompleter';

YASQE.registerAutocompleter(prefixCompleter);
YASQE.registerAutocompleter(propertiesCompleter);
YASQE.registerAutocompleter(classesCompleter);
YASQE.defaults.autocompleters = ['prefixCompleter', 'propertiesCompleter', 'classesCompleter', 'variables'];

const styles = () => {
  return Object.assign({
    yasguiContainer: {
      clear: 'both'
    }
  }, globalStyles);
};

class YasqeManager extends Component {

  _setRef(componentNode) {
    this._rootNode = componentNode;
  }

  componentDidMount() {
    const yasqe = new YASQE(this._rootNode, {
      createShareableLink: null,
      showQueryButton: false,
      classList: this.props.classList,
      propertyList: this.props.propertyList,
      editorHeight: '321px',
      persistenceId: null,
      value: this.props.initialQuery
    });
    this.props.onSetup(yasqe);
  }

  render() {

    const { classes } = this.props;

    return (
      <div className={classes.yasguiContainer}>
        <div ref={this._setRef.bind(this)} />
      </div>
    );
  }
}

YasqeManager.defaultProps = {
  initialQuery: "SELECT * WHERE {\n    ?s ?p ?o .\n}\nLIMIT 10"
};

YasqeManager.propTypes = {
  classes: PropTypes.object,
  classList: PropTypes.array,
  propertyList: PropTypes.array,
  initialQuery: PropTypes.string,
  onSetup: PropTypes.func.isRequired
};

export default withStyles(styles)(YasqeManager);